import { useState } from 'react';

export const useVisualizationSettings = () => {
    const [visualSettings, setVisualSettings] = useState({
        colorBy: '',
        sizeBy: '',
        colorRules: {},
        sizeRange: { min: 20, max: 50 },
        basemap: 'esriOcean'
    });

    const handleVisualizationChange = (setting, value) => {
        setVisualSettings(prev => ({
            ...prev,
            [setting]: value,
            ...(setting === 'colorBy' ? { colorRules: {} } : {})
        }));
    };

    const handleColorRuleChange = (value, color) => {
        setVisualSettings(prev => ({
            ...prev,
            colorRules: {
                ...prev.colorRules,
                [value]: color
            }
        }));
    };

    return {
        visualSettings,
        handleVisualizationChange,
        handleColorRuleChange
    };
};
